import { Component } from '@angular/core';
import { ITooltipParams } from 'ag-grid-enterprise';
import { ITooltipAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-grid-tooltip',
    templateUrl: './grid-tooltip.component.html',
    styleUrls: ['./grid-tooltip.component.scss'],
    standalone: false
})
export class GridTooltipComponent implements ITooltipAngularComp {
  html = '';

  agInit(params: ITooltipParams): void {
    this.html = params.value;
  }
}
